import PeopleIcon from '@material-ui/icons/People';
import SupplierList from './SupplierList';

export default {
    list: SupplierList,
    icon: PeopleIcon,
};
